import { en } from './en.js'

export const id = structuredClone(en)

id.visualGameAdmin.conversionFunnelDevices = {'label': 'Jenis perangkat sumber', 'all': 'Semua', 'desktop': 'Komputer', 'mobile': 'Ponsel', 'tablet': 'Tablet'}

id.visualGameAdmin.pageFunnel = {'button': 'Lihat corong halaman', 'title': 'Corong halaman', 'home': 'Beranda', 'auth': 'Masuk atau daftar', 'game': 'Halaman permainan', 'note': 'Sesi yang melewati langkah berurutan sesuai waktu dan perangkat. Termasuk dialog masuk PC. Data historis tanpa pelacakan tidak dapat dipulihkan.', 'loading': 'Memuat…', 'error': 'Gagal memuat', 'sessions': 'sesi'}

id.visualGameAdmin.pageFunnel.viewUsers = 'Lihat pengguna'
id.visualGameAdmin.pageFunnel.peopleUnit = 'pengguna'
id.visualGameAdmin.pageFunnel.timesUnit = 'kali'

id.visualGameAdmin.pageFunnel.userFilter_all = 'Corong: daftar atau masuk'

id.visualGameAdmin.pageFunnel.userFilter_sign_up = 'Corong: terdaftar dalam periode'

id.visualGameAdmin.pageFunnel.userFilter_login = 'Corong: masuk dalam periode'

id.visualGameAdmin.usageActivity = {
  "title": "Penggunaan situs · Aktivitas",
  "button": "Lihat detail",
  "all": "Semua aktivitas",
  "search": "Cari pengguna, game atau ID",
  "user": "Pengguna",
  "game": "Game",
  "kind": "Aktivitas",
  "status": "Status",
  "time": "Waktu",
  "detail": "Lihat catatan",
  "empty": "Tidak ada catatan",
  "loading": "Memuat…",
  "error": "Gagal memuat",
  "note": "Input menggunakan peristiwa pihak pertama dan dapat berbeda dari GA4. Teks dan sesi yang tidak tercatat tidak disimpulkan.",
  "limit": "Menampilkan 1000 catatan terbaru. Persempit rentang tanggal untuk melihat lainnya.",
  "text_input": "Input teks",
  "voice_input": "Input suara",
  "slice_video": "Pembuatan klip",
  "global_video": "Pembuatan video lengkap",
  "free_game": "Pembuatan game gratis"
}

Object.assign(id.visualGameAdmin.usageActivity, {
  "status_queued": "Antrean",
  "status_running": "Berjalan",
  "status_ready": "Selesai",
  "status_failed": "Gagal",
  "status_submitting": "Mengirim",
  "status_submitted": "Terkirim",
  "status_ok": "Berhasil",
  "status_error": "Gagal",
  "status_generating": "Membuat",
  "status_generation_failed": "Pembuatan gagal",
  "status_pending_review": "Menunggu tinjauan",
  "status_review_rejected": "Ditolak",
  "status_published": "Diterbitkan",
  "status_archived": "Diarsipkan"
})

id.visualGameAdmin.usageActivity.records = 'catatan'
